import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/auth';
import { 
    Monitor, 
    Package, 
    Users, 
    ShoppingCart, 
    FileText, 
    BarChart3, 
    Download, 
    LogOut,
    Menu,
    X,
    Home,
    Layers,
    UserCheck,
    Activity,
    Archive,
    BookOpen,
    IndianRupee,
    UserX,
    Crown,
    Zap,
    Rocket,
    Truck,
    Map,
    MapPin,
    Building,
    Bell,
    HelpCircle,
    Droplets,
    Link2,
    Globe,
    RotateCcw
} from 'lucide-react';

const Navbar = (props) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const location = useLocation();

    const navigationItems = [
        {
            title: 'Dashboard',
            icon: Home,
            path: '/inventory/v1.2/',
            category: 'main'
        },
        {
            title: 'Home',
            icon: Monitor,
            path: '/inventory/v1.2/',
            category: 'delivery'
        },
        {
            title: 'Products',
            icon: Package,
            path: '/inventory/v1.2/Products',
            category: 'inventory'
        },
        {
            title: 'Product Packages',
            icon: Layers,
            path: '/inventory/v1.2/product-package',
            category: 'inventory'
        },
        {
            title: 'Product Profiles',
            icon: UserCheck,
            path: '/inventory/v1.2/profiles',
            category: 'inventory'
        },
        {
            title: 'Accessories',
            icon: Zap,
            path: '/inventory/v1.2/accessories',
            category: 'inventory'
        },
        {
            title: 'Accessory Purchases',
            icon: ShoppingCart,
            path: '/inventory/v1.2/accessory-purchases',
            category: 'inventory'
        },
        {
            title: 'Unserviceable Area Requests',
            icon: MapPin,
            path: '/inventory/v1.2/unserviceable-area-requests',
            category: 'management'
        },
        {
            title: 'Memberships',
            icon: Crown,
            path: '/inventory/v1.2/memberships',
            category: 'inventory'
        },
        {
            title: 'Delivery Profiles',
            icon: Truck,
            path: '/inventory/v1.2/delivery-profiles',
            category: 'inventory'
        },
        {
            title: 'Referral Content',
            icon: FileText,
            path: '/inventory/v1.2/referral-contents',
            category: 'inventory'
        },
        {
            title: 'Referral Ledger',
            icon: BookOpen,
            path: '/inventory/v1.2/referral-ledger',
            category: 'reports'
        },
        {
            title: 'Referral Stats',
            icon: BarChart3,
            path: '/inventory/v1.2/referral-stats',
            category: 'reports'
        },
        {
            title: 'User Activity Report',
            icon: Activity,
            path: '/inventory/v1.2/user-activity-report',
            category: 'reports'
        },
        {
            title: 'User Analytics Report',
            icon: BarChart3,
            path: '/inventory/v1.2/user-analytics-report',
            category: 'reports'
        },
        {
            title: 'User Summary Report',
            icon: Users,
            path: '/inventory/v1.2/user-summary-report',
            category: 'reports'
        },
        {
            title: 'Orders',
            icon: ShoppingCart,
            path: '/inventory/v1.2/Orders',
            category: 'transactions'
        },
        {
            title: 'Refunds',
            icon: IndianRupee,
            path: '/inventory/v1.2/refunds',
            category: 'transactions'
        },
        {
            title: 'Payment Links',
            icon: Link2,
            path: '/inventory/v1.2/payment-links',
            category: 'transactions'
        },
        {
            title: 'Delivery Management',
            icon: Truck,
            path: '/inventory/v1.2/delivery-management',
            category: 'transactions'
        },
        {
            title: 'Delivery Can Transactions',
            icon: Package,
            path: '/inventory/v1.2/delivery-transactions',
            category: 'transactions'
        },
        {
            title: 'Can Returns',
            icon: RotateCcw,
            path: '/inventory/v1.2/can-returns',
            category: 'transactions'
        },
        {
            title: 'Transactions',
            icon: FileText,
            path: '/inventory/v1.2/transactions',
            category: 'transactions'
        },
        {
            title: 'Users',
            icon: Users,
            path: '/inventory/v1.2/Users',
            category: 'management'
        },
        {
            title: 'Inventory Status',
            icon: BarChart3,
            path: '/inventory/v1.2/inventory-status',
            category: 'monitoring'
        },
        {
            title: 'Stock',
            icon: Archive,
            path: '/inventory/v1.2/cans-in-stock',
            category: 'monitoring'
        },
        {
            title: 'Can Management',
            icon: Droplets,
            path: '/inventory/v1.2/cans/manage',
            category: 'management'
        },
        {
            title: 'TXN Ledgers',
            icon: BookOpen,
            path: '/inventory/v1.2/transaction-ledger',
            category: 'reports'
        },
        {
            title: 'User\'s Can Ledgers',
            icon: BookOpen,
            path: '/inventory/v1.2/ledger',
            category: 'reports'
        },
        {
            title: 'Sales',
            icon: IndianRupee,
            path: '/inventory/v1.2/sales',
            category: 'reports'
        },
        {
            title: 'Water Quality',
            icon: FileText,
            path: '/inventory/v1.2/water-quality',
            category: 'reports'
        },
        {
            title: 'Downloads',
            icon: Download,
            path: '/inventory/v1.2/downloads',
            category: 'tools'
        },
        {
            title: 'Get Started',
            icon: Rocket,
            path: '/inventory/v1.2/getstarted',
            category: 'tools'
        },
        {
            title: 'FAQs',
            icon: HelpCircle,
            path: '/inventory/v1.2/faqs',
            category: 'tools'
        },
        {
            title: 'KML Extractor',
            icon: MapPin,
            path: '/inventory/v1.2/kml-extractor',
            category: 'tools'
        },
        {
            title: 'Notifications',
            icon: Bell,
            path: '/inventory/v1.2/notifications',
            category: 'management'
        },
        {
            title: 'Account Deletion',
            icon: UserX,
            path: '/inventory/v1.2/account-deletion',
            category: 'management'
        },
        {
            title: 'Delivery Agents',
            icon: Truck,
            path: '/inventory/v1.2/agents',
            category: 'management'
        },
        {
            title: 'Serviceable Areas',
            icon: Map,
            path: '/inventory/v1.2/serviceable-areas',
            category: 'management'
        },
        {
            title: 'Super Serviceable Areas',
            icon: Globe,
            path: '/inventory/v1.2/super-serviceable-areas',
            category: 'management'
        },
        {
            title: 'Sectors',
            icon: Layers,
            path: '/inventory/v1.2/sectors',
            category: 'management'
        },
        {
            title: 'Inventory Nodes',
            icon: Building,
            path: '/inventory/v1.2/inventory-nodes',
            category: 'inventory'
        },
        {
            title: 'Agent Sector Assignments',
            icon: UserCheck,
            path: '/inventory/v1.2/agent-sector-assignments',
            category: 'management'
        }
    ];

    const categories = {
        main: { title: 'Dashboard', color: 'primary' },
        delivery: { title: 'Delivery', color: 'info' },
        inventory: { title: 'Inventory', color: 'success' },
        transactions: { title: 'Transactions', color: 'warning' },
        management: { title: 'Management', color: 'danger' },
        monitoring: { title: 'Monitoring', color: 'secondary' },
        reports: { title: 'Reports', color: 'dark' },
        tools: { title: 'Tools', color: 'light' }
    };

    const isActiveLink = (path) => {
        return location.pathname === path;
    };

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    const authSidebar = (
        <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`} style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            width: isCollapsed ? '80px' : '280px',
            backgroundColor: '#1e293b',
            color: 'white',
            transition: 'all 0.3s ease',
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            overflowX: 'hidden'
        }}>
            {/* Header */}
            <div className="sidebar-header" style={{
                padding: '1rem',
                borderBottom: '1px solid #334155',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                <div className="d-flex align-items-center">
                    <div className="bg-primary rounded p-2 me-3">
                        <Monitor size={24} className="text-white" />
                    </div>
                    {!isCollapsed && (
                        <div>
                            <h5 className="mb-0 text-white fw-bold">CANMAN</h5>
                            <small className="text-muted">Inventory System</small>
                        </div>
                    )}
                </div>
                <button 
                    className="btn btn-link text-white p-0"
                    onClick={toggleSidebar}
                    style={{ border: 'none', background: 'none' }}
                >
                    {isCollapsed ? <Menu size={20} /> : <X size={20} />}
                </button>
            </div>

            {/* Navigation */}
            <div className="sidebar-nav" style={{ 
                padding: '1rem 0',
                flex: 1,
                overflowY: 'auto'
            }}>
                {Object.entries(categories).map(([categoryKey, category]) => {
                    const categoryItems = navigationItems.filter(item => item.category === categoryKey);
                    if (categoryItems.length === 0) return null;

                    return (
                        <div key={categoryKey} className="nav-category mb-3">
                            {!isCollapsed && (
                                <div className="category-header" style={{
                                    padding: '0.5rem 1rem',
                                    fontSize: '0.75rem',
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    color: '#64748b',
                                    letterSpacing: '0.05em'
                                }}>
                                    {category.title}
                                </div>
                            )}
                            {categoryItems.map((item, index) => {
                                const IconComponent = item.icon;
                                const isActive = isActiveLink(item.path);
                                
                                return (
                                    <Link
                                        key={index}
                                        to={item.path}
                                        className="nav-link"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '0.75rem 1rem',
                                            color: isActive ? '#3b82f6' : '#cbd5e1',
                                            textDecoration: 'none',
                                            backgroundColor: isActive ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                                            borderRight: isActive ? '3px solid #3b82f6' : '3px solid transparent',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isActive) {
                                                e.target.style.backgroundColor = 'rgba(148, 163, 184, 0.1)';
                                                e.target.style.color = '#f1f5f9';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isActive) {
                                                e.target.style.backgroundColor = 'transparent';
                                                e.target.style.color = '#cbd5e1';
                                            }
                                        }}
                                    >
                                        <IconComponent 
                                            size={20} 
                                            className={`${isCollapsed ? '' : 'me-3'} flex-shrink-0`}
                                        />
                                        {!isCollapsed && (
                                            <span className="nav-text" style={{
                                                fontSize: '0.875rem',
                                                fontWeight: isActive ? '600' : '400'
                                            }}>
                                                {item.title}
                                            </span>
                                        )}
                                    </Link>
                                );
                            })}
                        </div>
                    );
                })}
            </div>

            {/* Footer */}
            <div className="sidebar-footer" style={{
                padding: '1rem',
                borderTop: '1px solid #334155',
                marginTop: 'auto',
                flexShrink: 0
            }}>
                <button
                    onClick={props.logout}
                    className="btn w-100 d-flex align-items-center justify-content-center"
                    style={{
                        backgroundColor: 'rgba(239, 68, 68, 0.1)',
                        border: '1px solid rgba(239, 68, 68, 0.2)',
                        color: '#ef4444',
                        padding: '0.75rem'
                    }}
                >
                    <LogOut size={20} className={isCollapsed ? '' : 'me-2'} />
                    {!isCollapsed && <span>Logout</span>}
                </button>
            </div>
        </div>
    );

    const guestSidebar = (
        <div className="sidebar" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            width: '280px',
            backgroundColor: '#1e293b',
            color: 'white',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <div className="text-center">
                <div className="bg-primary rounded-circle p-4 mb-4 mx-auto" style={{ width: 'fit-content' }}>
                    <Monitor size={48} className="text-white" />
                </div>
                <h3 className="text-white mb-4">CANMAN</h3>
                <Link 
                    to="/inventory/v1.2/login"
                    className="btn btn-primary btn-lg"
                >
                    Login to Continue
                </Link>
            </div>
        </div>
    );

    return (
        <React.Fragment>
            {!props.auth.loading && (
                <React.Fragment>
                    {props.auth.isAuthenticated ? authSidebar : guestSidebar}
                    {/* Main content offset */}
                    <div 
                        className="main-content"
                        style={{
                            marginLeft: props.auth.isAuthenticated ? (isCollapsed ? '80px' : '280px') : '280px',
                            transition: 'margin-left 0.3s ease',
                            minHeight: '100vh',
                            backgroundColor: '#f8fafc'
                        }}
                    >
                        {/* Content will be rendered here by routes */}
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

Navbar.propTypes = {
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps, { logout })(Navbar);
